<template>
  <div class="ui-block">
    <div class="ui-block-title">
      <h6 class="cta-title">Groups you may like</h6>
    </div>

    <!-- W-Friend-Pages-Added -->

    <ul class="widget w-friend-pages-added notification-list friend-requests">
      <li class="inline-items" v-for="group in groups_to_show" :key="group.id">
        <div class="author-thumb">
          <img
            :src="getGroupImagePath(group)"
            alt="author"
            class="group-img fit-contain"
          />
        </div>
        <div class="notification-event">
          <router-link :to="`/s-app/group-page/${group.id}`"
            ><span class="group-name-info">
              {{ group.name }}
            </span>
          </router-link>
          <div class="group-info">
            <span>{{ group.city }}</span>
            <span>{{ showPrivacy(group.privacy) }}</span>
            <span>{{ group.membersCount }} members</span>
          </div>
        </div>
        <span class="notification-icon">
          <SButtonMaterial
            v-if="!verifyJoinedGroup[group.id]"
            buttonType="button"
            color="secondary"
            textColor="white"
            materialClass="dense"
            @button="openModal(group)"
            text="JOIN"
            data-cy="btnJoinGroup"
            :data-cy-groupname="group.name"
          />
          <md-icon v-else class="member-icon" md-src="/svg-icons/checkIcon.svg" />
        </span>
        <p class="group-description">{{ group.description }}</p>
      </li>
    </ul>
    <LoadingSpinner position="relative" class="p-4" v-if="isFetching" />
    <div v-if="!end_of_groups" class="text-center py-3">
      <span v-if="groups_length < groups.length" class="like-link" @click="loadMoreGroups"
        >View more</span
      >
    </div>
    <ModalNewJoinRequest
      @joinrequest="tryToJoinGroup"
      :name="groupName"
      :request="requesting"
      :result="modalResponse"
      :buttonTitle="setButtonTitle"
      @resetButton="resetModal"
    />
    <ModalWelcomeGroup
      :name="groupName"
      :groupKey="groupKey"
      :fromFeed="true"
    />
  </div>
</template>

<script>
import GroupHelper from "@/mixins/GroupHelper.vue";
import ModalNewJoinRequest from "@/components/molecules/ModalNewJoinRequest";
import SButtonMaterial from "@/material-components/atoms/SButtonMaterial.vue";
import groupPrivacy from "@/enum/group-privacy";
import LoadingSpinner from "@/material-components/atoms/LoadingSpinner.vue";
import UserHelperVue from "@/mixins/UserHelper.vue";
import ModalWelcomeGroup from "@/components/molecules/ModalWelcomeGroup.vue";

export default {
  name: "GroupsYouMayLike",
  props: ["groups"],
  mixins: [GroupHelper, UserHelperVue],
  components: { ModalNewJoinRequest, LoadingSpinner, SButtonMaterial, ModalWelcomeGroup },
  data() {
    return {
      modalResponse: null,
      requesting: false,
      requestingId: null,
      setButtonTitle: "Send message",
      groupName: null,
      pickGroup: null,
      verifyJoinedGroup: {},
      groups_length: 0,
      groups_to_show: [],
      end_of_groups: false,
      isFetching: false,
      groupKey: null,
    };
  },
  methods: {
    async tryToJoinGroup(e) {
      await this.fetchModerator({ group: { id: this.pickGroup.id } });
      this.requesting = true;
      const result = await this.newRequestToJoin({
        group: this.pickGroup,
        msg: e,
      });
      await this.sendUserGroupMessageForModerator(this.getModerator, this.loggedUser, e, this.pickGroup.id);
      this.requesting = false;
      if (result.result === "You are already a member of this group") {
        this.modalResponse =
          "You already have a request to join this group. Please, wait for the moderator acceptance.";
      } else {
        this.modalResponse = result.result;
      }
      this.setButtonTitle = "Ok";
    },
    tooltipText(group) {
      switch (group.privacy) {
        case 1:
          return "Join this group";
        case 2:
          return "Ask to join";
      }
      return "";
    },
    showPrivacy(privacy) {
      switch (privacy) {
        case 1:
          return "Public";
        case 2:
          return "Private";
        case 3:
          return "Hidden";
        default:
          return "";
      }
    },
    async openModal(g) {
      this.groupName = g.name;
      this.pickGroup = g;
      this.groupKey = g.id;
      if (g.privacy === groupPrivacy.PUBLIC) {
        this.joinGroup({
          groupId: this.pickGroup.id,
          groupName: this.groupName,
          groupKey: this.groupKey,
        });
        this.verifyJoinedGroup[this.pickGroup.id] = true;
        $("#welcome-modal").modal("show");
      } else {
        await this.fetchModerator({ group: g });
        $("#join-request").modal("show");
      }
    },
    closeModal() {
      this.$refs.modal.closeModal();
    },
    resetModal() {
      this.setButtonTitle = "Send message";
      this.modalResponse = null;
      this.requesting = false;
    },
    loadMoreGroups() {
      let result = [...this.groups.slice(this.groups_length, this.groups_length + 5)];

      if (result.length === 0) {
        this.end_of_groups = true;
        return;
      }

      this.groups_to_show.push(...result);
      this.groups_length += result.length;
    },
  },
  watch: {
    groups(newGroups) {
      if (newGroups && this.groups_to_show.length === 0) this.loadMoreGroups();
    },
  },
  created() {
    this.isFetching = true;
  },
  async mounted() {
    await this.fetchGroupsYouMayLike();
    this.isFetching = false;
  },
  updated() {
    $("[data-toggle='tooltip']").tooltip({ trigger: "hover" });
  },
};
</script>

<style lang="scss" scoped>
.w-friend-pages-added .notification-event {
  max-width: 45%;
}
.member-icon {
  padding-right: 40px;
}
.md-button {
  min-width: unset;
  margin-top: unset;
}
.group-name-info {
  color: $black;
  font-weight: 400;
}
.group-name-info:hover {
  color: $primary;
}
.cta-title {
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 25px;
  display: flex;
  align-items: center;
  text-align: center;
  letter-spacing: 1.25px;
  color: $black;
  opacity: 0.7;
}
.group-img {
  height: 34px;
  width: 34px;
}
.group-info {
  display: flex;
  flex-direction: column;
}
.group-info span {
  font-size: 14px;
}
.group-description {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  height: 15px;
  width: 250px;
}
.like-link {
  color: $primary;
  background-color: transparent;
  cursor: pointer;
  transition: all 0.15s ease;
}
.like-link:hover {
  color: #63bab9;
}
.inline-items {
  overflow-wrap: break-word;
}
.ui-block {
  min-width: 250px !important;
  width: 100%;
}
</style>
